import { createSelector } from '@reduxjs/toolkit';

import { RootState } from '..';
import { getLoadCasesForActiveComponentDesign } from './getLoadCasesForActiveComponentDesignSelector';

export const getSelectedCheckResultsLoadCase = createSelector(
  getLoadCasesForActiveComponentDesign,
  (state: RootState) => state.selections.selectedCheckResultsLoadCaseGuid,
  (loadCases, selectedLoadCaseGuid) => {
    if (loadCases == null) return null;
    const loadCase = loadCases.find((possibleLoadCase) => possibleLoadCase.guid === selectedLoadCaseGuid);
    return loadCase !== undefined ? loadCase : null;
  },
);
